module.exports = __webpack_public_path__ + "static/img/t-shirt_right_red.09cca8ff.png";